import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { Link as RouterLink, isRouteErrorResponse, useRouteError } from "react-router";

/** The route error page, shown whenever a route throws a Response or error. */
export function RouteError() {
  const error = useRouteError();

  let status = "Error";
  let message = "Something went wrong.";
  if (isRouteErrorResponse(error)) {
    status = String(error.status);
    message = error.status === 404 ? "That order could not be found." : error.statusText || message;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h1" sx={{ fontSize: "3rem", mb: 1 }}>
          {status}
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Go home
        </Button>
      </Box>
    </Container>
  );
}
